var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h2',{attrs:{"id":"time"},domProps:{"innerHTML":_vm._s(_vm.time)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }